<template>
  <div class="fixed z-10 inset-0 overflow-y-auto" style="min-height: 500px;">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div
          class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full sm:p-6"
          role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
          <button type="button" @click="closeModal"
                  class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
            <span class="sr-only">Close</span>
            <!-- Heroicon name: x -->
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="space-y-8 divide-y divide-gray-200">
          <div>
            <div class="mt-3 text-center sm:mt-0 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                {{ transEdit('therapist-remove-day') }} {{ date }}
              </h3>
            </div>
            <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4">
              <div class="form-check" v-if="true">
                <div class="relative flex items-start">
                  <div class="flex items-center h-5">
                    <input id="remove-day-modal-remove-bookings-checkbox"
                           type="checkbox"
                           class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded">
                  </div>
                  <div class="ml-3 text-sm">
                    <label for="remove-day-modal-remove-bookings-checkbox" class="font-medium text-gray-700">
                      {{ transEdit('therapist-remove-day-unbook') }}
                    </label>
                  </div>
                </div>
              </div>

              <div v-else>
                <h3 class="sm:grid-cols-6 text-lg leading-6 font-medium text-gray-900">
                  {{ transEdit('therapist-remove-day-info') }}
                </h3>

              </div>
            </div>

          </div>
          <div class="pt-5">
            <div class="flex justify-end">
              <button type="button" @click="closeModal"
                      class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
                {{ transEdit('cancel') }}
              </button>
              <button type="submit" @click="removeDay"
                      class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-tlmblue2 hover:bg-tlmblue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-tlmblue2">
                {{ transEdit('remove') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "therapist-dash-modal-remove-day",
  props: ['route_delete_day', 'therapist_self_admin', 'date'],
  methods: {
    removeDay: function () {
      let self = this;
      let thisModal = $("#remove-day-modal");
      let deleteExistingBookings = false;

      if (this.therapist_self_admin) {
        let deleteExistingBookingsCheckbox = $("#remove-day-modal-remove-bookings-checkbox");
        deleteExistingBookings = deleteExistingBookingsCheckbox.is(':checked');
      }

      axios.delete(this.$portalUrl(self.route_delete_day), {
        data: {
          date: this.date,
          deleteExistingBookings: deleteExistingBookings,
        }
      })
          .then(function (response) {
            self.$emit('close');
          })
          .catch(function (error) {
          });

      thisModal.modal('toggle');
    },
    closeModal() {
      this.$emit('close');
    },
  }
}
</script>

<style scoped>

</style>
